import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedDevolucionesAgregarSeleccionarComponent {
  devoluciones = []
  onClose
  operadora
  procesando = false
  resultados = []
  pdfs = []
  xmls = []

  constructor ($q, $fileSystem, ViaticosViaticoDevolucionesAgregarDecodificarService) {
    this.$q = $q
    this.$fileSystem = $fileSystem
    this.parseViaticosViaticoDevolucionesAgregarDecodificarService = ViaticosViaticoDevolucionesAgregarDecodificarService
  }

  seleccionar () {
    this.$fileSystem.select(true, '.pdf,.xml')
      .then((files) => (this.validarArchivos(files)))
  }

  validarArchivos (files) {
    files.forEach((item) => {
      switch (item.type) {
        case 'text/xml':
          this.xmls.push(item)
          break
        case 'application/pdf':
          this.pdfs.push(item)
          break
      }
    })

    this.xmls.forEach((item, index) => {
      this.devoluciones[index] = {}
      this.devoluciones[index].xml = item
      this.devoluciones[index].pdf = this.pdfs.filter((elemento) => item.name.substring(0, item.name.length - 4) ===
        elemento.name.substring(0, item.name.length - 4))[0] || null
      if (this.devoluciones[index].pdf !== null)
        this.pdfs.splice(this.pdfs.indexOf(this.devoluciones[index].pdf), 1)
    })

    if (this.pdfs.length) {
      this.pdfs.forEach((item) => (this.devoluciones.push({xml: null, pdf: item})))
    }

    if (this.devoluciones.length) {
      this.procesar()
    }
  }

  procesar () {
    this.procesando = true

    const parse = this.parseViaticosViaticoDevolucionesAgregarDecodificarService.parse.bind(this.parseViaticosViaticoDevolucionesAgregarDecodificarService)
    const promesas = this.devoluciones.map((item) => parse(this.operadora.rfc, item.xml, item.pdf))

    this.$q.all(promesas)
      .then((resultados) => (this.resultados = resultados))
      .finally(() => {
        this.procesando = false
        this.cerrar()
      })
  }

  cerrar () {
    this.onClose({$event: {detail: this.resultados}})
  }
}

module
  .component(
    'viaticosSharedDevolucionesAgregarSeleccionar'
    , {
      controller: ViaticosSharedDevolucionesAgregarSeleccionarComponent
      ,
      template
      ,
      bindings: {
        operadora: '<',
        onClose: '&',
      }
      ,
    },
  )



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/devoluciones/agregar/seleccionar/component.js